export default function Hero() {
  const stats = [
    { label: '每日更新', value: '200+' },
    { label: '高清片源', value: '10万+' },
    { label: '流畅不卡', value: '99.9%' },
  ];

  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-950 via-background-900 to-background-950">
        <div className="absolute inset-0 opacity-[0.06] bg-[radial-gradient(ellipse_at_center,_oklch(var(--primary-500))_0%,_transparent_60%)]"></div>
        <div className="absolute top-0 right-0 w-[600px] h-[600px] opacity-[0.04] bg-[radial-gradient(circle_at_70%_30%,_oklch(var(--accent-500))_0%,_transparent_50%)]"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 pt-[72px]">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 text-primary-300 text-xs md:text-sm font-medium mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-400 animate-pulse"></span>
              数字颜色系列 — 热门更新中
            </p>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading leading-tight tracking-wide">
              <span className="text-foreground-50">妖精视频</span>
              <span className="block mt-2 text-xl md:text-2xl lg:text-3xl text-foreground-400 font-body font-normal">高清数字颜色系列在线平台</span>
            </h1>

            <p className="mt-4 md:mt-5 text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              汇聚红桃视频、小蓝视频、黑桃视频等特色数字颜色系列内容。妖精视频每日精选高清片源，涵盖91视频风格热门专题与久久视频同款经典，97视频品质保证，即点即播无需等待。无论是热门连载追踪还是经典回顾，这里都能满足你的观看需求。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-6">
              {stats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <span className="text-xl md:text-2xl font-bold text-accent-400 tracking-tight">{stat.value}</span>
                  <span className="text-xs md:text-sm text-foreground-600">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-7">
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); handleClick('#topics'); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-foreground-50 font-medium rounded-lg text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-base"></i>
                立即探索热门
              </a>
              <a
                href="#carousel"
                onClick={(e) => { e.preventDefault(); handleClick('#carousel'); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-700/50 hover:bg-background-600/50 text-foreground-300 hover:text-foreground-100 font-medium rounded-lg text-sm transition-all duration-200 border border-background-600/50 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-gallery-line text-base"></i>
                查看焦点专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px] relative">
            <div className="relative rounded-xl overflow-hidden aspect-[4/3] bg-background-800/50">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20composition%20with%20geometric%20shapes%20in%20crimson%20red%20and%20deep%20charcoal%20tones%2C%20warm%20amber%20light%20streaks%20over%20a%20moody%20dark%20atmosphere%2C%20film%20grain%20texture%2C%20digital%20media%20aesthetic%2C%20luxurious%20theater%20vibe%2C%20dramatic%20color%20gradient%20from%20deep%20red%20to%20black%2C%20minimalist%20and%20sophisticated%20composition&width=1040&height=780&seq=hero-visual-01&orientation=landscape"
                alt="妖精视频数字颜色系列主视觉"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) {
                    target.parentElement.style.display = 'none';
                  }
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
            </div>

            <div className="absolute -bottom-3 -right-3 hidden md:flex items-center gap-2 bg-background-800/90 backdrop-blur-sm px-4 py-2 rounded-lg border border-background-600/50">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs text-foreground-400">正在热播</span>
            </div>

            <div className="absolute -top-3 -left-3 hidden md:flex items-center gap-2 bg-primary-500/20 backdrop-blur-sm px-3 py-1.5 rounded-full border border-primary-500/30">
              <span className="text-xs text-primary-300 font-medium">4K 超清</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}